
export const MQTT_CHANNEL = "stg/"
export const DOMAIN = "https://rhythms24x7.co.in/api";
export const REPORT_DOMAIN = "https://rhythms24x7.co.in/report-api";
export const MQTT_BROKER_URL = "wss://rhythms24x7.co.in:8883";
export const REPORT_EXPIRY_TIME = 120;
